import { render, staticRenderFns } from "./PartnershipTypes.vue?vue&type=template&id=6fb95a80&scoped=true&"
import script from "./PartnershipTypes.vue?vue&type=script&lang=js&"
export * from "./PartnershipTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb95a80",
  null
  
)

export default component.exports